import { Component, OnInit } from '@angular/core';
import { AduraService } from '@app/shared/services/adura.service';
import { GefahrAdmin } from '@app/shared/classes/adura/gefahr';

@Component({
  selector: 'app-adura-admin-stammdaten-gefahr',
  templateUrl: './adura-admin-stammdaten-gefahr.component.html',
  standalone: false
})
export class AduraAdminStammdatenGefahrComponent implements OnInit {
  gefahr: GefahrAdmin[] = [];
  setListError = false;

  constructor(private aduraService: AduraService) {
  }

  ngOnInit(): void {
    this.aduraService.listGefahrAdmin()
      .subscribe({
        next: result => {
          this.gefahr = result;
          this.setListError = false;
        },
        error: error => {
          this.setListError = true;
          console.error(error);
        }
      });
  }

  onGefahrDeleted(index: number) {
    this.gefahr.splice(index, 1);
  }

  reloadEntries(): void {
    this.ngOnInit();
  }
}
